import { createAxios } from 'ts/createAxios';
import { Site } from 'types/site';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

export const addSiteAdminCard = async (siteId: string, icCard: string) => {
  const api = createAxios();
  const data = await api.post('/sites/admin-cards', {
    siteId: siteId,
    card: icCard,
  });
  return data;
};

export const deleteSiteAdminCard = async (icCardId: number) => {
  const api = createAxios();
  const data = await api.delete(`/sites/admin-cards/${icCardId}`);
  return data;
};

export const getSites = async (params?: {
  successCallback?: (data: { sites: Site[] }) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  failedCallback?: (error: any) => void;
}) => {
  const { successCallback, failedCallback } = params || {};

  try {
    const { data } = await createAxios().get<{ sites: Site[] }>(
      API_ENDPOINTS.SITE
    );

    successCallback?.(data);
  } catch (e) {
    handleError(e);
    failedCallback?.(e);
  }
};
